const isNumeric = (n: any): n is number => {
  return n !== true && n !== false && n !== null && !Number.isNaN(+n);
};

export default isNumeric;
